import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'

import { CompanySearchField } from '../../../../../../../companies/elements/CompanySearchField'
import { createCustomerFormFromCompany } from '../../../../../../utils/createCustomerFormFromCompany'
import { useCustomerForm } from '../../../../contexts/customerFormContext'

export const CompanyName = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem, getValues, reset, setValue } = customerForm

  const handleCompanySelect = useCallback(
    (company: Partial<Company> | Partial<FrenchCompany>) => {
      const customer = createCustomerFormFromCompany(company)

      reset({
        ...getValues(),
        address: customer.address,
        businessId: customer.businessId,
        eInvoiceAddress: customer.eInvoiceAddress,
        entityType: customer.entityType,
        vatNumber: customer.vatNumber,
      })

      // Ensure the reset has been fully applied before setting `autoCompletedFields`, so the highlight state is not wiped out.
      window.requestAnimationFrame(() => {
        setValue('autoCompletedFields', {
          'address.city': !!customer.address?.city,
          'address.country': !!customer.address?.country,
          'address.pobox': !!customer.address?.pobox,
          'address.streetAddress1': !!customer.address?.streetAddress1,
          businessId: !!customer.businessId,
          'eInvoiceAddress.address': !!customer.eInvoiceAddress?.address,
          vatNumber: !!customer.vatNumber,
        })
      })
    },
    [getValues, reset, setValue],
  )

  return (
    <FormItem
      label={t('customer_modal.form.company_name.label')}
      name="companyName"
      render={({ field }) => <CompanySearchField {...field} onSelectCompany={handleCompanySelect} />}
    />
  )
}
